import { QueryClient } from "@tanstack/react-query";

/**
 * TanStack Query verwaltet hier nur Serverzustand, der nicht in Dexie liegt
 * (Sitzung, Einladungen, Auswertungen auf Abruf). Listen und Artikel kommen
 * über Dexie-Live-Queries, damit die Oberfläche offline dieselbe Quelle hat.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 2,
      refetchOnWindowFocus: false,
      networkMode: "offlineFirst",
    },
    mutations: {
      networkMode: "offlineFirst",
    },
  },
});
